import { map } from "leaflet";



export const all_routes = {
 
  meetingFormView: "/Meeting-Form",
  MeetingSummeryView: "/Meeting-Summery",


  // auth routes routes
  login: "/login",
  login2: "/login-2",
  login3: "/login-3",
  userRegister: "/register",
  otpVerification: "/otp-verification",
  success: "/success",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  error404: '/error-404',
  error500: '/error-500'

  //  3 route 
};
